import { render, staticRenderFns } from "./FilterBoard.vue?vue&type=template&id=2397efec&scoped=true&"
import script from "./FilterBoard.vue?vue&type=script&lang=js&"
export * from "./FilterBoard.vue?vue&type=script&lang=js&"
import style0 from "./FilterBoard.vue?vue&type=style&index=0&id=2397efec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397efec",
  null
  
)

export default component.exports